module.exports = __webpack_public_path__ + "img/slide_interno_vainilla.003c26e1.webp";